/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { IFair, anyTodo } from '@umati/dashboard-types';
import { getFairs } from '../../api/fairs';
import { FairHandling } from 'utilities/FairHandling';
import { actions } from '../actionTypes';
import { checkBucketsAvailability } from 'api/buckets';

export interface IFairState {
  fairs: {
    [key: string]: IFair;
  };
  apiError: anyTodo | null;
}

export const initialFairsState: IFairState = {
  fairs: {},
  apiError: null,
};

const fairs = (state = initialFairsState, action): IFairState | undefined => {
  switch (action.type) {
    case actions.LOAD_FAIRS_SUCCESS: {
      return {
        ...state,
        fairs: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export async function fetchFairs(dispatch /* , getState */) {
  try {
    const response = await getFairs();
    const buecktsAvailable = await checkBucketsAvailability();
    const fairs = FairHandling.deserializeFairsFromBackendRequest(response, buecktsAvailable.staticBucketReachable);
    dispatch({ type: actions.LOAD_FAIRS_SUCCESS, payload: fairs });
  } catch (error) {
    dispatch({ type: actions.LOAD_FAIRS_ERROR, payload: error });
  }
}

export default fairs;
